exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.error[data-v-1efe53d2] {\n    margin-top: 3px;\n    margin-bottom: 10px;\n    color: #FF6044;\n}\n", ""]);

// exports
